import React from 'react';
import type { SwitchProps } from '@mui/material';
import { styled, Switch as MaterialSwitch } from '@mui/material';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';

type InputProps = {
  primaryColor: string;
};

const MUISwitch = styled(MaterialSwitch)<InputProps>(({ primaryColor }) => ({
  height: 26,
  width: 48,
  padding: 0,
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#DFDFDF',
    opacity: 1,
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 20,
    height: 20,
    margin: 1,
    marginLeft: 2,
    backgroundColor: '#fff',
  },
  '& .Mui-checked': {
    color: `${primaryColor} !important`,
  },
  '& .Mui-checked + .MuiSwitch-track': {
    backgroundColor: `${primaryColor} !important`,
    opacity: `1 !important`,
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    color: '#f5f5f5 !important',
  },
  '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: '#bdbdbd !important',
    opacity: '0.6 !important',
  },
}));

const Switch = (props: SwitchProps) => {
  const p = useAppSelector(getThemeLookup);

  return (
    <MUISwitch
      primaryColor={p('switchChecked', ['backgroundColor']).backgroundColor || ''}
      {...props}
    />
  );
};

export default Switch;
